export default __webpack_public_path__ + "75aae8133433c09c667ca2d1f8abe6be.svg";